import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IIndexHarmonizationReportItem } from "../model/IndexHarmonizationReportItem";
import IndexHarmonizationReportMapper from "../service/IndexHarmonizationReportMapper";

export default class GetIndexHarmonizationReportInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexHarmonizationReportItem>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(categoryTypeId: number) {
    return this.resource.execute(
      `reports/harmonization-report/raw`,
      IndexHarmonizationReportMapper,
      () => {},
      {
        query: {
          categoryTypeId
        }
      }
    );
  }
}
